import QmIcon from './component/QmIcon'
import {
	Affix,
	Alert,
	BackTop,
	Badge,
	Breadcrumb,
	Button,
	Calendar,
	Card,
	Carousel,
	Cascader,
	Checkbox,
	Col,
	Collapse,
	DatePicker,
	Dropdown,
	Form,
	Icon,
	Input,
	InputNumber,
	Layout,
	LocaleProvider,
	Menu,
	Message,
	Modal,
	Notification,
	Pagination,
	Popconfirm,
	Popover,
	Progress,
	QueueAnim,
	Radio,
	Rate,
	Row,
	Select,
	Slider,
	Spin,
	Steps,
	Switch,
	Table,
	Tabs,
	Tag,
	TimePicker,
	Timeline,
	Tooltip,
	Transfer,
	Tree,
	TreeSelect,
	Upload,
	Validation
} from 'antd'


export {
	Affix,
	Alert,
	BackTop,
	Badge,
	Breadcrumb,
	Button,
	Calendar,
	Card,
	Carousel,
	Cascader,
	Checkbox,
	Col,
	Collapse,
	DatePicker,
	Dropdown,
	Form,
	Icon,
	Input,
	InputNumber,
	Layout,
	LocaleProvider,
	Menu,
	Message,
	Modal,
	Notification,
	Pagination,
	Popconfirm,
	Popover,
	Progress,
	QueueAnim,
	Radio,
	Rate,
	Row,
	Select,
	Slider,
	Spin,
	Steps,
	Switch,
	Table,
	Tabs,
	Tag,
	TimePicker,
	Timeline,
	Tooltip,
	Transfer,
	Tree,
	TreeSelect,
	Upload,
	Validation,
	QmIcon
}